import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderWithBack from '../Components/HeaderWithBack';

import Loading from '../Components/Loading';

import styles from '../Styles/Account.module.css';
import AddSiteMainPhotos from '../Components/AddSiteMainPhoto';
import ChangeSiteMainPhoto from '../Components/ChangeSiteMainPhoto';

const SiteMainImages = () => {
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    const [photos, setPhotos] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(false);
    const [selectedPhotoId, setSelectedPhotoId] = React.useState('');

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();

        setLoading(true);

        axios.get('/api/site-main-photos', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            setWarning('');
            setPhotos(response.data);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [reload]);

    const formatDateTime = (isoDate) => {
        if (!isoDate) return 'Некорректная дата';
        const cleanDate = isoDate.replace(/\.\d+Z$/, '');

        const date = new Date(cleanDate);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const [isAddSiteMainPhotos, setIsAddSiteMainPhotos] = React.useState(false);
    const [isSiteMainPhoto, setIsSiteMainPhoto] = React.useState(false);

    return (
        <>
            {isAddSiteMainPhotos && <AddSiteMainPhotos closeModal={() => {setIsAddSiteMainPhotos(false);}} onSuccess={() => {setReload(true);}}/>}
            {isSiteMainPhoto && <ChangeSiteMainPhoto closeModal={() => {setIsSiteMainPhoto(false);}} id={selectedPhotoId} onSuccess={() => {setReload(true);}}/>}

            <div className="main">
                <HeaderWithBack />
                <div className={styles.horizontalData}>
                    <div className={styles.liningData}>
                        <button
                            type="button"
                            className="button"
                            style={{ width: 'fit-content' }}
                            onClick={() => {
                                setIsAddSiteMainPhotos(true);
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="plus"
                            >
                                <path
                                    fill="currentColor"
                                    d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"
                                />
                            </svg>
                            Добавить
                        </button>
                        <div className={styles.table}>
                            <div className={styles.lineHeader}>
                                <a style={{ width: '20%' }}>Позиция отображения</a>
                                <a style={{ width: '55%' }}>Фотография</a>
                                <a style={{ width: '15%' }}>Дата добавления</a>
                                <a style={{ width: '10%' }}></a>
                            </div>
                            {loading ? <Loading />
                            : warning ?
                                <div className={styles.line}>
                                    <a>{warning}</a>
                                </div>
                            : (
                                photos.map((photo) => (
                                    <div className={styles.line} key={photo.number}>
                                        <a style={{ width: '20%' }}>{photo.position ?? 'Главная фотография сайта'}</a>
                                        <a style={{ width: '55%' }}>
                                            <img
                                            src={photo.path}
                                            alt="Фотография"
                                            style={{ width: 'auto', maxWidth: '100%', maxHeight: '200px', objectFit: 'cover' }}
                                            />
                                        </a>
                                        <a style={{ width: '15%' }}>{formatDateTime(photo.created_at)}</a>
                                        <a style={{ width: '10%', display: 'flex', justifyContent: 'center', borderRight: 'none' }}>
                                            <svg onClick={() => {setIsSiteMainPhoto(true); setSelectedPhotoId(photo.id)}} style={{margin: '0 4px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="pen"><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>
                                        </a>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SiteMainImages;
